/**
 * A textual representation of the current state of the printer, e.g. Operational" or Printing"
 */
export enum PrinterState {
  Operational = 'Operational',
  Printing = 'Printing'
}
